.bz{flex-shrink:0;}